import axios from "axios";
import { baseApiUrl, httpRequest, getHttpHeaders } from "../ApiUtils";


const questionDomainApiUrl = `${baseApiUrl}/api/QuestionDomainOption`;

export async function getQuestionDomain() {
    return await httpRequest(fetchQuestionDomain.bind(this));
}

async function fetchQuestionDomain() {
    let config = getHttpHeaders();
    return await axios.get(`${questionDomainApiUrl}`, config);
}

export async function getQuestionDomainById(id) {
    return await httpRequest(fetchQuestionDomainById.bind(this, id));
}

async function fetchQuestionDomainById(id) {
    let config = getHttpHeaders();
    return await axios.get(`${questionDomainApiUrl}/${id}`, config);
}

export async function getQuestionDomainByQuestionId(questionId) {
    return await httpRequest(fetchQuestionDomainByQuestionId.bind(this, questionId));
}

async function fetchQuestionDomainByQuestionId(questionId) {
    let config = getHttpHeaders();
    return await axios.get(`${questionDomainApiUrl}/Question/${questionId}`, config);
}

export async function addQuestionDomain(newQuestionDomain) {
    return await httpRequest(postQuestionDomain.bind(this, newQuestionDomain));
}

async function postQuestionDomain(newQuestionDomain) {
    let config = getHttpHeaders();
    return await axios.post(`${questionDomainApiUrl}`, newQuestionDomain, config);
}

export async function updateQuestionDomain(updatedQuiz) {
    return await httpRequest(putQuestionDomain.bind(this, updatedQuiz));
}

async function putQuestionDomain(updatedQuiz) {
    let config = getHttpHeaders();
    return await axios.put(`${questionDomainApiUrl}`, updatedQuiz, config);
}